module.exports = __webpack_public_path__ + "img/C2A391_523728_785741_694836-256px.26023e3b.png";